import React from 'react';
import {connect} from 'react-redux'


class MarketingSection extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const d = new Date(this.props.marketing.testimonial_created_at);
        const month = d.toLocaleString("en-US", { month: "long" });
        const dateFormatted =
            `${month}_${d.getDate()}_${d.getFullYear()}`.toLowerCase();
        const downloadTestimonialFileName = this.props.state.feedback_detail.user.firstname +
            "_" +
            this.props.state.feedback_detail.user.lastname +
            "_testimonial_video_" +
            (this.props.state.business.alt_name ?? this.props.state.business.name) +
            "_" +
            dateFormatted +
            "." +
            this.props.marketing.testimonial_extension;

        return (
            <div className="card-body marketing-section border-bottom">
                <div className={'d-flex align-items-center mb-2'}>
                    <h4 id="marketing-preview" className={'mr-2'}>{__('Marketing Testimonial Preview')}</h4>
                </div>
                {this.props?.marketing &&
                    <div className="row detail-list mt-4">
                        <div className="col-md-12 mt-0 note-input">
                            {this.props.marketing?.testimonial_connected_feedback?.link &&
                                <h5>{__('Connected Feedback')}: <a
                                    href={this.props.marketing.testimonial_connected_feedback.link}
                                    target="_blank">{this.props.marketing.testimonial_connected_feedback.feedback_id}</a>
                                </h5>
                            }

                            {/*
                              * iOS Safari shows only the play button on a blank background (RTF-4766) instead of
                              * a thumbnail because it doesn't decode any frame until playback starts. Two things
                              * fix that for the first-frame-as-poster behaviour desktop already had:
                              *   1. `#t=0.1` media fragment — tells the browser to seek to 0.1s and paint that
                              *      frame as an implicit poster (the file's bucket serves byte ranges).
                              *   2. preload="metadata" — makes iOS fetch enough to decode that frame.
                              * We deliberately omit the `<source type>` hint: testimonial uploads are commonly
                              * .MOV (video/quicktime), and the old hardcoded type="video/mp4" mislabelled them,
                              * which suppresses iOS preview rendering while still allowing gesture playback. With
                              * no type, the browser sniffs the actual content and renders the preview correctly.
                              * playsInline keeps playback inline rather than triggering iOS fullscreen takeover.
                              */}
                            {this.props.marketing?.testimonial_video_url &&
                                <video className="d-block video-testimonial w-50" controls playsInline preload="metadata">
                                    <source src={`${this.props.marketing.testimonial_video_url}#t=0.1`}/>
                                </video>
                            }

                            <div className="flex flex-row">
                                {/* Download Testimonial Btn */}
                                <a download={downloadTestimonialFileName}
                                   href={`${this.props.marketing.testimonial_video_url}?dl=${downloadTestimonialFileName}`}
                                   className="d-inline-block btn btn-outline-primary btn-sm mt-2">
                                    <i className="fas fa-download mr-2"></i>
                                    { __('Download Testimonial') }
                                </a>

                                <a className="d-inline-block btn btn-outline-primary btn-sm mt-2 ml-3" href={this.props.marketing.all_testimonials_link} target="_blank">
                                    <i className="fas fa-external-link-alt mr-2" aria-hidden="true"></i>
                                    {__('View All Testimonials')}
                                </a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {feedback_id: state.selected_feedback, current_user: state.current_user, state}
}

export default connect(mapStateToProps)(MarketingSection)
